/**
 * Название текущей страницы для заголовка X-Client-Page.
 * Бэк складывает его рядом с версией изменённых данных, поэтому в сообщении о конфликте
 * видно не только кто и когда, но и откуда пришло изменение.
 */
const TABS: TStringMap<string> = {
  spending: "Состав затрат",
  finance: "Финансирование",
  summary: "Общие данные",
  content: "Состав проекта",
  contentTask: "Задания",
  ipd: "ИРД",
  agents: "Агенты",
  orderQuestion: "Задания по проекту",
};

const PAGES: Array<[string, string]> = [
  ["/finance-requests", "Фин. запросы"],
  ["/expenses/overhead", "Накладные расходы"],
  ["/expenses", "Расходы"],
  ["/spending/employee", "Сотрудники"],
  ["/spending/departments", "Отделы"],
  ["/spending/workload", "План работ"],
  ["/spending/timesheet", "Табель"],
  ["/spending", "Управление организацией"],
  ["/reports", "Отчёты"],
  ["/agents", "Контрагенты"],
];

export function describeLocation(pathname: string, hash: string) {
  if (pathname.startsWith("/orders")) {
    const tab = /tab=([^&]+)/.exec(hash || "");
    const name = tab ? TABS[tab[1]] : "";

    return name ? `Карточка договора → ${name}` : "Карточка договора";
  }

  const page = PAGES.find(([path]) => pathname.startsWith(path));

  return page ? page[1] : "";
}

export function currentPage() {
  try {
    return describeLocation(window.location.pathname, window.location.hash);
  } catch {
    return "";
  }
}
